import type { KnowledgeBaseDocumentType, ResourceManagementType } from '@libs/enums';
import type { ItemAttributes, ItemNames } from '@ps-smart-cp/ppfw-client';
import { Characters, ItemName, Locale, ValueSet } from '@ps-smart-cp/ppfw-client';

interface KnowledgeBaseMst {
  code: string;
  name: string;
  type: ResourceManagementType;
  documentType: KnowledgeBaseDocumentType;
  note: string;
}

interface Schema {
  knowledgeBaseMst: KnowledgeBaseMst;
}

const titleNames = {
  maintenance: ItemName.of(
    [Locale.ja, 'ナレッジベースマスタメンテナンス'],
    [Locale.en, 'Knowledge Base Master Maintenance'],
  ),
};

const buttonNames = {
  download: ItemName.of([Locale.ja, 'ダウンロード'], [Locale.en, 'Download']),
};

const names = {
  code: ItemName.of([Locale.ja, 'コード'], [Locale.en, 'Code']),
  name: ItemName.of([Locale.ja, '名称'], [Locale.en, 'Name']),
  type: ItemName.of([Locale.ja, 'タイプ'], [Locale.en, 'Type']),
  documentType: ItemName.of([Locale.ja, 'ドキュメント種別'], [Locale.en, 'Document Type']),
  note: ItemName.of([Locale.ja, '備考'], [Locale.en, 'Note']),
} satisfies ItemNames<Schema['knowledgeBaseMst']>;

const attributes = {
  code: Characters.preset.freeFormat({ maxLen: 128, required: false }),
  name: Characters.preset.freeFormat({ maxLen: 256, required: false }),
  type: ValueSet.new(),
  documentType: ValueSet.new(),
  note: Characters.preset.freeFormat({ maxLen: 500, required: false }),
} satisfies ItemAttributes<Schema['knowledgeBaseMst']>;

const knowledgeBaseMst = {
  attributes,
  buttonNames,
  names,
  titleNames,
};

interface KnowledgeBaseMst {
  schema: Schema;
}

export type { KnowledgeBaseMst };
export { knowledgeBaseMst };
